// src/components/AppHeader.js
import React from "react";

const AppHeader = () => (
  <div className="text-center mt-4 mb-4">
    <h1 className="fw-bold">Library of Forgotten Lives</h1>
  </div>
);

export default AppHeader;
